declare const jQuery: any;
const $ = jQuery;

export function initLangSelector(): void
{
	$(`[data-lang-select]`).on("change", function (ev) {
		const url: string = $(this).val();
		window.location.href = url;
	});
}
